export const TERM_DATA = [
    {
        value: 'Monthly',
        label: 'Monthly',
    },
    {
        value: 'Quarterly',
        label: 'Quarterly',
    },
    {
        value: 'Annually',
        label: 'Annually',
    },
    {
        value: 'Billed on actual',
        label: 'Billed on actual',
    },
];

export const CUSTOMER = [
    {
        "id": 1,
        "code": "ARC",
        "name": "ARC Inc.",
        "email": "admin@arcinc.com",
        "address": "2000, St Peter",
        "city": "Villey",
        "state": "CA",
        "zip": "123456",
        "country": "US"
    },
    {
        "id": 2,
        "code": "ARC1",
        "name": "ARC1 Inc.",
        "email": "admin1@arcinc.com",
        "address": "2000, St Peter",
        "city": "Villey",
        "state": "CA",
        "zip": "123456",
        "country": "US"
    }
]

export const CUSTOMER_FIELDS = [
    { name: 'code', label: 'Code', rules: [{ required: true, message: 'Please enter the Code!' }] },
    { name: 'name', label: 'Name', rules: [
        { required: true, message: 'Please enter the Name!' },
        { min: 2, message: 'Name must be at least 2 characters' },
    ]},
    { name: 'email', label: 'Email', rules: [
        { required: true, message: 'Please enter the Code!' },
        { type: 'email', message: 'Please enter a valid email' },
    ]},
    { name: 'address', label: 'Address', rules: [{ required: true, message: 'Please enter the Address!' }] },
    { name: 'city', label: 'City', rules: [{ required: true, message: 'Please enter the City!' }] },
    { name: 'state', label: 'State', rules: [{ required: true, message: 'Please enter the State!' }] },
    { name: 'zip', label: 'Zip', rules: [
      { required: true, message: 'Please enter the Zip!' },
    ]},
    { name: 'country', label: 'Country', rules: [{ required: true, message: 'Please enter the Country!' }] },
    // { name: 'invoice_due_days', label: 'Invoice Due Days', rules: [
    //     { required: true, message: 'Please enter the Invoice due days!' },
    //     { pattern: /^[0-9]+$/, message: 'Please enter valid Invoice due days!' }
    // ] },
];

export const ADD_CUSTOMER_DATA = {
    'code': '',
    'name': '',
    'email': '',
    'address': '',
    'city': '',
    'state': '',
    'zip': '',
    'country': '',
    'invoice_due_days': '',
}

export const PRODUCTS = [
    {
        "id": 1,
        "name": "Product-1",
        "sku": "product-sku-1",
        "description": "SKU product 1 description",
        "price": 500.00,
        "tax_code": "ABCDEF",
        "license_type": "Perpetual"
    },
    {
        "id": 1,
        "name": "Product-2",
        "sku": "product-sku-2",
        "description": "SKU product 2 description",
        "price": 100.00,
        "tax_code": "GHIJKL",
        "license_type": "Yearly renewal"
    }
]

export const SUBSCRIPTIONS = [
    {
        "id": "1",
        "product_id": "1",
        "customer_id": "1",
        "product": {
            "id": "1",
            "name": "P1 Updated",
            "sku": "12345",
            "description": "P1 Description Updated",
            "price": 150,
            "tax_code": "1234",
            "license_type": "Perpetual",
            "is_active": true
        },
        "customer": {
            "id": "1",
            "code": "AVI",
            "name": "Avinash",
            "email": "avi@avi.com",
            "is_active": true
        },
        "start_date": "2025-01-01",
        "end_date": "2025-12-31",
        "is_active": true,
        "amount": 150.0,
        "created_at": "2025-07-21T00:00:00.000Z",
        "updated_at": "2025-07-21T00:00:00.000Z"
    },
    {
        "id": "2",
        "product_id": "2",
        "customer_id": "2",
        "product": {
            "id": "2",
            "name": "P2 Updated",
            "sku": "4321",
            "description": "P2 Description Updated",
            "price": 100,
            "tax_code": "1234",
            "license_type": "Pass",
            "is_active": true
        },
        "customer": {
            "id": "2",
            "code": "JAY",
            "name": "Jayanth",
            "email": "jayanth@jayanth.com",
            "is_active": true
        },
        "start_date": "2025-02-01",
        "end_date": "2025-03-31",
        "is_active": true,
        "amount": 100.0,
        "created_at": "2025-07-21T00:00:00.000Z",
        "updated_at": "2025-07-21T00:00:00.000Z"
    }
]
